import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=0538a79a&scoped=true&"
import script from "./CompanyForm.vue?vue&type=script&lang=ts&"
export * from "./CompanyForm.vue?vue&type=script&lang=ts&"
import style0 from "../Company.scss?vue&type=style&index=0&id=0538a79a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0538a79a",
  null
  
)

export default component.exports